export enum QuestionType{
    REGULAR,
    IS_FACTOR,
    IS_NOT_FACTOR,
    IS_MULTIPLE,
    IS_NOT_MULTIPLE
}

export enum ChallengeMode{
    FIXED_TIME,
    SUDDEN_DEATH
}

export enum SchoolLevel{
    ELEMENTARY = 'ELEMENTARY',
    MIDDLE = "MIDDLE",
    HIGH = 'HIGH'
}

export enum UserRole {
    ADMIN = "admin",
    HOST = "host"
}